import type { SVGProps } from 'react';
import { IconBase } from './icon-base';

export function LoaderCircleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </IconBase>
  );
}
